import { QualityParameter, TicketKind } from '../../types/quality'
import { parseQualityParameterUuid } from './qualityBusinessHours'

export const QUALITY_PARAM_DEPARTAMENTO = 'departamento_qualidade'

export const TICKET_KIND_LABELS: Record<TicketKind, string> = {
  incident: 'Incidente',
  improvement: 'Melhoria',
  suggestion: 'Sugestão',
  not_applicable: 'Não aplicável',
}

export const TICKET_KIND_COLORS: Record<TicketKind, string> = {
  incident: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400',
  improvement: 'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400',
  suggestion: 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-400',
  not_applicable: 'bg-gray-100 text-gray-700 dark:bg-gray-700/50 dark:text-gray-300',
}

export const TICKET_KIND_BADGE_COLORS: Record<TicketKind, string> = {
  incident: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400',
  improvement: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400',
  suggestion: 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-400',
  not_applicable: 'bg-gray-100 text-gray-700 dark:bg-gray-700/50 dark:text-gray-300',
}

export function canUseNotApplicableKind(
  userDepartmentId: string | null | undefined,
  parameters: QualityParameter[],
): boolean {
  const qualityDeptId = parseQualityParameterUuid(parameters, QUALITY_PARAM_DEPARTAMENTO)
  if (!qualityDeptId || !userDepartmentId) return false
  return userDepartmentId === qualityDeptId
}

/** Usuário pertence ao departamento de qualidade (parâmetro departamento_qualidade). */
export function isQualityDepartmentUser(
  userDepartmentId: string | null | undefined,
  parameters: QualityParameter[],
): boolean {
  return canUseNotApplicableKind(userDepartmentId, parameters)
}

export function ticketKindsForForm(canNotApplicable: boolean, currentKind?: TicketKind): TicketKind[] {
  const base: TicketKind[] = ['incident', 'improvement', 'suggestion']
  if (canNotApplicable) return [...base, 'not_applicable']
  if (currentKind === 'not_applicable') return [...base, 'not_applicable']
  return base
}

export function kindLabel(kind: TicketKind | string | null | undefined): string {
  if (!kind) return '—'
  return TICKET_KIND_LABELS[kind as TicketKind] ?? String(kind)
}

const DESCRIPTION_LABEL_BY_KIND: Partial<Record<TicketKind, string>> = {
  incident: 'Descrição do Incidente',
  improvement: 'Descrição da Melhoria',
  suggestion: 'Descrição da Sugestão',
}

const DESCRIPTION_HINT_BY_KIND: Partial<Record<TicketKind, string>> = {
  incident: 'O que está acontecendo?',
  improvement: 'O que precisa ser melhorado?',
  suggestion: 'O que você sugere?',
}

const DESCRIPTION_PLACEHOLDER_BY_KIND: Partial<Record<TicketKind, string>> = {
  incident: 'Descreva o que aconteceu, em que momento e quem ou o que foi afetado.',
  improvement: 'Descreva a situação atual e o que deveria funcionar de forma diferente.',
  suggestion: 'Descreva sua ideia e como ela poderia ser aplicada no dia a dia.',
}

export function descriptionLabelForKind(kind: TicketKind | null | undefined): string {
  if (!kind) return 'Descrição'
  return DESCRIPTION_LABEL_BY_KIND[kind] ?? 'Descrição'
}

export function descriptionHintForKind(kind: TicketKind | null | undefined): string | null {
  if (!kind) return null
  return DESCRIPTION_HINT_BY_KIND[kind] ?? null
}

export function descriptionPlaceholderForKind(kind: TicketKind | null | undefined): string {
  if (!kind) return 'Descreva os detalhes do registro.'
  return DESCRIPTION_PLACEHOLDER_BY_KIND[kind] ?? 'Descreva os detalhes do registro.'
}

const JUSTIFICATION_LABEL_BY_KIND: Partial<Record<TicketKind, string>> = {
  incident: 'Justificativa do Incidente',
  improvement: 'Justificativa da Melhoria',
  suggestion: 'Justificativa da Sugestão',
}

const JUSTIFICATION_HINT_BY_KIND: Partial<Record<TicketKind, string>> = {
  incident: 'Por que isso precisa ser registrado?',
  improvement: 'Por que essa melhoria é necessária?',
  suggestion: 'Por que você está sugerindo isso?',
}

export function justificationLabelForKind(kind: TicketKind | null | undefined): string {
  if (!kind) return 'Justificativa'
  return JUSTIFICATION_LABEL_BY_KIND[kind] ?? 'Justificativa'
}

export function justificationHintForKind(kind: TicketKind | null | undefined): string | null {
  if (!kind) return null
  return JUSTIFICATION_HINT_BY_KIND[kind] ?? null
}
